export const getDraftBasePath = (isBulkEnabled) =>
  isBulkEnabled ? "/draft-bulk" : "/draft";

export const getDraftDetailPath = (orderNo, isBulkEnabled) => {
  const basePath = getDraftBasePath(isBulkEnabled);
  return orderNo ? `${basePath}/${orderNo}` : basePath;
};
